import type { ReactNode } from 'react'

interface IconTileProps {
  icon: ReactNode
  label: string
  onClick?: () => void
  selected?: boolean
  className?: string
  iconBgColor?: string
}

export function IconTile({
  icon,
  label,
  className = '',
  iconBgColor = 'bg-indigo-50',
}: IconTileProps) {
  const content = (
    <>
      <div
        className={`flex size-12.5 shrink-0 items-center justify-center rounded-lg ${iconBgColor} transition-colors`}
      >
        {icon}
      </div>
      <p className="tracking-base w-full max-w-22 text-center text-xs leading-4 break-keep text-neutral-900">
        {label}
      </p>
    </>
  )

  return (
    <div className={`flex flex-col items-center gap-2 ${className}`}>
      {content}
    </div>
  )
}
